export const GET_SEARCH_DATA = 'GET_SEARCH_DATA'

export const GET_SEARCH_BTN = 'GET_SEARCH_BTN'